import { getBusinessUnit } from "@shared/Utils/analytics-utils";

export type GA4LinkBlockEvent = {
  event: "button_click";
  element_category: string;
  element_cta: string;
  element_url: string;
  element_description?: string;
  business_unit: "B2C" | "B2B";
  deeplink_click_id?: string;
};

const APP_DEEPLINK_HOST = "app.ice.no";
const DEEPLINK_CLICK_ID_PARAM = "deeplink_click_id";

export const getHeadingOfLink = (link: HTMLElement): string => {
  const elementDescription = link.dataset.elementDescription ?? link.dataset.description;

  if (elementDescription && elementDescription.trim() !== "") {
    return elementDescription;
  }

  // Rendered server side from the editorial title, so it is not affected by browser translation
  const analyticsTitle = link.closest<HTMLElement>("[data-analytics-title]")?.dataset.analyticsTitle?.trim();

  return analyticsTitle && analyticsTitle !== "" ? analyticsTitle : "undefined";
};

const sendLinkClickEvent = (link: HTMLElement, deeplinkClickId?: string) => {
  const ga4Event: GA4LinkBlockEvent = {
    event: "button_click",
    element_category: link.dataset.elementCategory ? link.dataset.elementCategory : link.getAttribute("data-id") ?? "",
    element_cta: link.dataset.titleText ?? link.innerText ?? "",
    element_url: link.getAttribute("href") ?? "",
    business_unit: getBusinessUnit(),
    element_description: getHeadingOfLink(link),
    ...(deeplinkClickId ? { [DEEPLINK_CLICK_ID_PARAM]: deeplinkClickId } : {}),
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(ga4Event);
};

const isAppDeeplink = (href: string): boolean => {
  try {
    return new URL(href, window.location.href).hostname === APP_DEEPLINK_HOST;
  } catch {
    return false;
  }
};

const handleLinkClick = (link: HTMLElement) => {
  const href = link.getAttribute("href") ?? "";

  if (!isAppDeeplink(href) || typeof window.crypto?.randomUUID !== "function") {
    sendLinkClickEvent(link);
    return;
  }

  const deeplinkClickId = window.crypto.randomUUID();
  const url = new URL(href, window.location.href);
  url.searchParams.set(DEEPLINK_CLICK_ID_PARAM, deeplinkClickId);

  link.setAttribute("href", url.toString());
  sendLinkClickEvent(link, deeplinkClickId);
};

export const bootstrapLinkBlockAnalytics = () => {
  const links = [...document.querySelectorAll<HTMLElement>("[data-element-category], .js-ga-send-click-event")].filter(
    (el) => el.classList.contains("js-ga-send-click-event") || !!el.dataset.elementCategory?.trim(),
  );

  for (const link of links) {
    link.addEventListener("click", () => handleLinkClick(link));
  }
};

export const sendExpandClickEvent = (title: string, isExpanded: boolean) => {
  const ga4Event: GA4LinkBlockEvent = {
    event: "button_click",
    element_category: "mobilabonnement_bestill",
    element_cta: title,
    element_url: "undefined",
    business_unit: getBusinessUnit(),
    element_description: isExpanded ? "Open" : "closed",
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(ga4Event);
};
